/***
 * Created on 2024/4/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useReducer} from 'react';
import device_phone_svg from '../../../../../../static/img/utils/ic--device--phone.svg';
import {formatDate, formatTime} from "../../../../../../service/datetime";
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../../../hook/pre_check_password";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../../../../../service/api";
import {initState, qnapAuthReducer} from "../../../../../../service/qnap_auth_reducer";
import ShowSigninAgainDialog from "../../../../../common/modal_dialog/show_signin_again_dialog";
import VerifyPassword from "../../verify_password";
import {useBoundedStore} from 'common/Store';

function QnapAuthPairDevicePanelRow({device}) {
    const { t } = useTranslation();
    const {checkPassword} = usePreCheckPassword();
    const [state, dispatch] = useReducer(qnapAuthReducer, initState);
    const queryClient = useQueryClient();
    const store = useBoundedStore();

    const removeMutate = useMutation({
        mutationFn: async (reg_id) => await apiDelete(`/ajax/qnap_auth/device/${reg_id}`, null),
        onSuccess: async (data) => {
            if (data?.signin_required) {
                dispatch({type: 'toggleSigninAgain', value: true});
            }
            else {
                dispatch({type: 'toggleVerifyPassword', value: false});
                await queryClient.invalidateQueries({
                    queryKey: ['profile']
                });
                store.globalAlert.setAlert(t('@Your device {{mobile_device_name}} has been removed@', {mobile_device_name: data?.device?.device?.device_name}), 'success', true);
            }
        }
    });

    const removeDevice =  async (reg_id) => {
        await removeMutate.mutateAsync(reg_id);
    }

    const onRemoveDevice = async (reg_id) => {
        await checkPassword({
            onSuccess: async () => {
                await removeDevice(reg_id);
            },
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, opts: {closeSelf: true}})
        });
    }

    return (
        <div className="flex-table-row">
            <div className="flex-table__cell flex-table-row__cell w-21" data-label={t('@Device Name')}>
                <div className="comp-group-info">
                    <div className="group-info--img round-full">
                        <img src={device_phone_svg} alt=""/>
                    </div>
                    <div className="group-info--detail">
                        <div className="group-info--detail__main-text">{device?.device?.device_name || device?.device?.model_name}</div>
                    </div>
                </div>
            </div>
            <div className="flex-table__cell flex-table-row__cell w-20" data-label="Modal/OS Version">
                <div className="cell-text">
                    <span>{device?.device?.model_name}</span><span>/</span><span>{device?.device?.device_os}</span>
                </div>
            </div>
            <div className="flex-table__cell flex-table-row__cell w-22" data-label="Date Added"><span
                className="cell-text">{`${formatDate(t, device?.added_on, true)} ${formatTime(device?.added_on)}`}</span></div>
            <div className="flex-table__cell flex-table-row__cell w-22" data-label="Last Login"><span
                className="cell-text">{device?.last_login ? `${formatDate(t, device?.last_login, true)} ${formatTime(device?.last_login)}` : '-'}</span></div>
            <div className="flex-table__cell flex-table-row__cell w-15">
                <button className="q-btn q-btn--default btn-small btn-rounded-full min-w-0 !pl-18 !pr-18 !color-red" onClick={() => onRemoveDevice(device.id)}>
                    {t('@Remove@')}
                </button>
            </div>

            {state.showVerifyPassword && <VerifyPassword showModal={state.showVerifyPassword} closeModal={()=>dispatch({type: 'toggleVerifyPassword', value: false})} dispatch={dispatch} state={state} callback={async () => await removeDevice(device.id)}/>}
            {state.showSigninAgain && <ShowSigninAgainDialog showModal={state.showSigninAgain} closeModal={()=>dispatch({type: 'toggleSigninAgain', value: false})} />}
        </div>
    );
}

export default QnapAuthPairDevicePanelRow;